import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

/**
 * Inject a unique request ID into API requests that can be used to correlate
 * requests on the frontend with requests on the backend.
 **/
export function requestIdInterceptorFn(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  req = req.clone({
    headers: req.headers.set('x-ninety-request-id', uuidv4()),
  });

  return next(req);
}
